import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, insideImages } from '../data/content';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(insideImages.length - 1, i));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      setIndex(Math.max(0, Math.min(insideImages.length - 1, i)));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="blueprint-grid bg-ink px-3 py-4 sm:px-6" data-id="element-115" data-mp="a2o3oog3rxft">
      <div className="mx-auto max-w-2xl" data-id="element-116" data-mp="a0uxfa9ejf8c">
        <h2 className="text-center font-display text-[1.55rem] font-extrabold uppercase leading-none text-white sm:text-[2.1rem]" data-id="element-117" data-mp="61ckp1rqiagl">
          LOOK <span className="text-hazard" data-id="element-118" data-mp="jzj45cvxs7wq">INSIDE</span>
        </h2>
        <p className="mt-1 text-center font-display text-[0.78rem] font-bold uppercase text-hazard sm:text-[0.92rem]" data-id="element-119" data-mp="f196mvmqov7y">
          See CONSTRUCTION SITE PRO™ In Action
        </p>
        <p className="mt-1 text-center text-[0.78rem] leading-[1.35] text-steel sm:text-[0.9rem]" data-id="element-120" data-mp="3iihlr7q31gyz">
          Explore the ready-to-use planning sheets, crew coordination tools, material trackers,
          construction checklists, progress monitoring forms, professional reporting templates, and
          practical site management resources included in the complete system.
        </p>

        <div className="relative mt-2" data-id="element-121" data-mp="34p04jtkvcgc4">
          <div ref={trackRef} className="flex snap-x snap-mandatory overflow-x-auto rounded-md border-2 border-hazard bg-graphite [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" role="group" aria-roledescription="carousel" aria-label="Interior pages of Construction Site Pro" tabIndex={0} data-id="element-122" data-mp="2zsrrqmu58z84">
            {insideImages.map((img, i) => <a key={img.src} href={PURCHASE_ANCHOR} className="flex w-full shrink-0 snap-center items-center p-1.5" aria-label={`Page ${i + 1} of ${insideImages.length} — get the complete system`} data-id="element-123" data-mp="1hicn3dudzrw9" data-mpi={i}>
                <img src={img.src} alt={img.alt} loading={i === 0 ? 'eager' : 'lazy'} className="mx-auto w-full rounded-sm bg-white shadow-md" data-id="element-124" data-mp="tp4bdy0m4c9b" />
              </a>)}
          </div>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 -translate-y-1/2 rounded-full border-2 border-hazard bg-ink/90 p-1.5 text-hazard shadow-md transition-colors duration-150 ease-out hover:bg-ink disabled:opacity-30" data-id="element-125" data-mp="2a3w5qghbjtl9">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-126" data-mp="26i8yyhs0bez3" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === insideImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 -translate-y-1/2 rounded-full border-2 border-hazard bg-ink/90 p-1.5 text-hazard shadow-md transition-colors duration-150 ease-out hover:bg-ink disabled:opacity-30" data-id="element-127" data-mp="21iw5vfajlbo2">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-128" data-mp="3lyhioblx9fli" />
          </button>
        </div>

        <div className="mt-1.5 flex items-center justify-center gap-1.5" data-id="element-129" data-mp="3hxnx3ovyccvs">
          {insideImages.map((img, i) => <button key={img.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} aria-current={i === index} className={`h-1.5 rounded-full transition-[width,background-color] duration-150 ease-out ${i === index ? 'w-5 bg-hazard' : 'w-1.5 bg-line'}`} data-id="element-130" data-mp="3p0cc8x217emq" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}